module.exports = __webpack_public_path__ + "static/media/static wallet - blue.4f0352ad.svg";